import {
  clearOnboardingLocalStorage,
  setOnboardingInProgress,
} from '~/modules/onboarding/utils/onboarding.util';
import {
  APPLIED_RECOMMENDATIONS,
  DISMISSED_RECOMMENDATIONS,
} from '~/modules/recommendations/constants/recommendation.const';

export const DEBUG_ANALYTICS_SESSION_KEY = 'shippo_debug_analytics';

export const isDebuggingAnalytics = (): boolean =>
  sessionStorage.getItem(DEBUG_ANALYTICS_SESSION_KEY) === 'true';

interface ShippoGlobal {
  clearRecommendationDismissal(): void;
  debugAnalytics(): void;
  forceOnboarding(): void;
  open2FAPage(): void;
}

export class ShippoTools {
  constructor() {
    this.setup();
  }
  private buildTools(): ShippoGlobal {
    return {
      clearRecommendationDismissal: () => {
        localStorage.removeItem(DISMISSED_RECOMMENDATIONS);
        localStorage.removeItem(APPLIED_RECOMMENDATIONS);
      },
      debugAnalytics: () => {
        sessionStorage.setItem(DEBUG_ANALYTICS_SESSION_KEY, 'true');
      },
      forceOnboarding: () => {
        clearOnboardingLocalStorage();
        setOnboardingInProgress(true);
        location.reload();
      },
      open2FAPage: () => {
        const email = window.prompt('Enter your email:');
        if (!email) return;

        const password = window.prompt('Enter your password:');
        if (!password) return;

        history.pushState({ key: 'default', state: { email, password } }, '', '/challenge');
        window.dispatchEvent(new PopStateEvent('popstate', { state: history.state }));
      },
    };
  }
  private setup() {
    if (!window.shippo) window.shippo = this.buildTools();
  }
}
